import { Form, Table } from "antd";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllTermination } from "../../redux/rtk/features/termination/terminationSlice";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Kolkata");

function GetAllTerminationData() {
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.termination);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [form] = Form.useForm();

    useEffect(() => {
        dispatch(getAllTermination());
    }, [dispatch]);

    const columns = [
        {
            title: "S.No",
            dataIndex: "serial",
            key: "serial"
        },
        {
            title: "Employee Name",
            dataIndex: "user",
            key: "user",
            render: (user) => `${user.firstName} ${user.lastName}`,
        },
        {
            title: "Termination Start",
            dataIndex: "terminationDate",
            key: "terminationDate",
            render: (terminationDate) =>
                dayjs(terminationDate).utc().format("DD-MM-YYYY"),
        },
        {
            title: "Termination Reason",
            dataIndex: "termination",
            key: "termination",
            render: (termination) => `${termination?.terminationReason || 'N/A'}`,
        },
        {
            title: "Detail",
            dataIndex: "detail",
            key: "detail",
            render: (text) => (text ? text : "No details"),
        },
        {
            title: "Exit Interview",
            dataIndex: "exitInterviewPerformed",
            key: "exitInterviewPerformed",
            render: (exitInterviewPerformed) =>
                exitInterviewPerformed ? "Yes" : "No",
        },
        {
            title: "Suitable For Reemployment",
            dataIndex: "suitableForReemployment",
            key: "suitableForReemployment",
            render: (suitableForReemployment) =>
                suitableForReemployment ? "Eligible" : "Not Eligible",
        },
    ];

    return (
        <div>
            <Table
                dataSource={list.map((item, index) => ({ ...item, serial: index + 1 }))}
                columns={columns}
                rowKey={(record) => record.id}
                loading={loading}
            />
        </div>
    );
}

export default GetAllTerminationData;



